<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11iGoFO/tc-custom/9780805096088.jpg?1735616154566" alt="This image is the cover for the book Rise to Greatness"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rise to Greatness
      </h1>
      <p class="bookDescription body article font2">
        <b>This <i>New York Times</i>–bestselling biography follows President Lincoln through one fateful year as he rose to the moment of America’s greatest crisis.</b><br/><br/>As 1862 dawned, the American republic was at death’s door. The federal government appeared overwhelmed, the US Treasury was broke, and the Union’s top general was gravely ill. The Confederacy—with its booming economy, expert military leadership, and commanding position on the battlefield—had a clear view to victory. To a remarkable extent, the survival of the country depended on the judgment, cunning, and resilience of the unschooled frontier lawyer who had recently been elected president.<br/><br/>Twelve months later, the tides of war had turned. The Union generals who would win the conflict had at last emerged, and the Confederate Army had suffered the key losses that would lead to its doom. The blueprint of modern America—an expanding colossus of industrial and financial might—had been indelibly inked. And the man who brought the nation through its darkest hour, Abraham Lincoln, had been forged into a singular leader.<br/><br/>In <i>Rise to Greatness</i>, David Von Drehle presents a vividly detailed and deeply human portrait of Lincoln as he quickly transformed into America’s greatest president.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Von Drehle
      </h2>
      
      <p class="authorDescription body article"><B>David von Drehle</B> is the author of three previous books, including the award-winning <I>Triangle</I>, a history of the Triangle shirtwaist factory fire that <I>The New York Times</I> called "social history at its best." An editor-at-large at <I>Time</I> magazine, he and his family live in Kansas City, Missouri.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Henry Holt and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3382b4f7